import ToggleSwitch from "pages/ManagementPage/questionSection/ToggleSwitch/ToggleSwitch";

export default ToggleSwitch;
